type CustomBorderIconProps = React.SVGProps<SVGSVGElement> & {
    style?: React.CSSProperties
}

const BorderOnlyBottomIcon = ({ style = {}, ...otherProps }: CustomBorderIconProps) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 257 257'
        fill='currentColor'
        style={{
            display: 'inline-block',
            flexShrink: 0,
            ...style
        }}
        {...otherProps}>
        <rect className='st0' x='32.11' y='74.97' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='74.97' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='74.97' width='21.42' height='21.42' />
        <rect className='st0' x='32.11' y='117.8' width='21.42' height='21.42' />
        <rect className='st0' x='74.95' y='117.8' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='160.63' width='21.42' height='21.42' />
        <path className='st0' d='M214.16,32.1H42.83c-5.89,0-10.71,4.82-10.71,10.71s4.82,10.71,10.71,10.71h171.33c5.89,0,10.71-4.82,10.71-10.71s-4.82-10.71-10.71-10.71Z' />
        <rect className='st0' x='32.11' y='160.63' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='160.63' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='117.8' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='117.8' width='21.42' height='21.42' />
        <rect className='st0' x='160.61' y='117.8' width='21.42' height='21.42' />
        <rect className='st0' x='32.11' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='74.95' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='117.78' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='203.45' y='203.46' width='21.42' height='21.42' />
        <rect className='st0' x='160.61' y='203.46' width='21.42' height='21.42' />
    </svg>
)

export default BorderOnlyBottomIcon
